import React from 'react';
import { StarIcon, CheckCircleIcon } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    id: 1,
    name: 'Tine Oosterbeek',
    title: 'Waardevolle informatie, direct toepasbaar',
    quote: 'Ik was sceptisch over een gratis webinar, maar dit was echt de moeite waard. Amee legt helder uit waarom bepaald gedrag van je hond eigenlijk communicatie is. Het stuk over oogwit en tongelen was voor mij het belangrijkste. Ik zie nu dat mijn Roemeense straathond Skipper al veel eerder signalen gaf voordat hij uitvalt. Nu kan ik ingrijpen voordat het escaleert.',
    date: '8 september 2024',
    verified: true,
    reviewCount: 4,
    stars: 5
  }, {
    id: 2,
    name: 'Nicolette de Vries',
    title: 'Zelfs na jaren nog veel geleerd',
    quote: 'Ik heb al 12 jaar honden, maar deze aanpak kende ik niet. Het webinar ging vooral over lichaamstaal en wat je hond probeert te vertellen. Wat mij opviel is dat veel gedrag dat ik als "normaal" beschouwde, eigenlijk stresssignalen zijn. Het hoofdafwenden bijvoorbeeld - ik dacht altijd dat mijn hond me negeerde, maar hij probeerde conflict te vermijden.',
    date: '15 september 2025',
    verified: false,
    reviewCount: 2,
    stars: 5,
    location: 'NL'
  }, {
    id: 3,
    name: 'Margaret van den Berg',
    title: 'Dit was de eerste keer dat ik een online webinar volgde',
    quote: 'en ik had er veel van opgestoken. Hoewel mijn honden zich meestal prima gedragen, vind ik vooral leren wat ik zelf nog kan verbeteren in de communicatie belangrijk. Dat is gelukt. Het webinar maakte duidelijk dat veel "probleemgedrag" eigenlijk miscommunicatie is. Ik zie nu bijvoorbeeld wanneer mijn hond echt wil spelen of wanneer hij met rust gelaten wil worden. De uitleg over conflictvermijdend gedrag was interessant. Ik reageer nu anders op mijn honden en merk dat ze rustiger zijn geworden. Wel vrij lang (anderhalf uur), dus zorg dat je tijd hebt. Maar de tijd vliegt voorbij omdat het interessant is.',
    date: '20 september 2025',
    verified: true,
    reviewCount: 2,
    stars: 5
  }, {
    id: 4,
    name: 'Hennie Buskermolen',
    title: 'Leerzaam! De 7 signalen die besproken werden waren duidelijk en met goede voorbeelden.',
    quote: 'Ik begrijp nu beter waarom mijn puppy sommige dingen doet en kan daar beter op reageren. De lichaamstaal-uitleg was het meest nuttig voor mij.',
    date: '3 september 2024',
    verified: false,
    reviewCount: 4,
    stars: 4,
    location: 'NL'
  }];
  const WebinarLink = ({
    children
  }: {
    children: React.ReactNode;
  }) => <a href="https://stresslessdogs.nl/mcc-gpm" className="text-green-600 hover:text-green-700 hover:underline" data-id="element-106">
      {children}
    </a>;
  return <section className="w-full bg-gray-50 py-12 px-4" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center text-gray-800" data-id="element-109">
          Wat baasjes ervaren wanneer ze dit toepassen
        </h2>
        <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-110">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-white p-6 rounded-lg shadow-md" data-id="element-111">
              <div className="flex items-center mb-2" data-id="element-112">
                <p className="text-gray-900 font-bold mr-2" data-id="element-113">
                  {testimonial.name}
                </p>
                <div className="flex items-center text-xs text-gray-500" data-id="element-114">
                  <span className="flex items-center mr-2" data-id="element-115">
                    <CheckCircleIcon className="h-3 w-3 text-green-500 mr-1" data-id="element-116" />
                    Geverifieerd
                  </span>
                  <span data-id="element-117">| {testimonial.reviewCount} reviews</span>
                </div>
              </div>
              <div className="flex mb-3" data-id="element-118">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-5 w-5 ${i < testimonial.stars ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} data-id="element-119" />)}
              </div>
              <p className="text-gray-800 font-medium mb-3" data-id="element-120">
                {testimonial.title}
              </p>
              <p className="text-gray-700 mb-4" data-id="element-121">
                {testimonial.quote.replace(/webinar/g, match => `${match}`)}
              </p>
              <p className="text-gray-500 text-sm" data-id="element-122">
                Datum van ervaring: {testimonial.date}
              </p>
            </div>)}
        </div>
        <div className="flex justify-center mb-8" data-id="element-123">
          <a href="https://stresslessdogs.nl/mcc-gpm" className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 text-lg" data-id="element-124">
            BEKIJK WEBINAR PLANNING
          </a>
        </div>
      </div>
    </section>;
};